"use client";

import { twMerge } from "tailwind-merge";
import TextEllipsisProgress from "../TextEllipsisProgress";
import { AUTO_POST_STATUS } from "./autoPostStatus";

/** Shared waiting feedback: fixed-width motion with one stable accessible description. */
export default function AutoPostWaitingStatus({ className }: { className?: string }) {
  return (
    <span className={twMerge("inline-flex min-w-0 max-w-full items-center", className)} data-auto-post-waiting="true">
      <span className="truncate" aria-hidden>Waiting for shorts</span>
      <span aria-hidden className="inline-flex w-[1em] shrink-0 items-center">
        <span className="inline-flex items-center motion-reduce:hidden"><TextEllipsisProgress speed={500} /></span>
        <span className="hidden motion-reduce:inline">...</span>
      </span>
      <span className="sr-only">{AUTO_POST_STATUS.waitingForShorts}</span>
    </span>
  );
}
